/**
 * @Author: gongzhichao
 * @Date: 2023
 * @Description: 路由文件
 */

import Vue from "vue";
import utils from "../utils";
import VueRouter from "vue-router";
import pcLayout from "@/components/pc/Layout/Layout.vue";
import mbLayout from "@/components/mobile/Layout/Layout.vue";

Vue.use(VueRouter);
// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routesP = [
  {
    path: "/",
    name: "pcLayout",
    redirect: "/home",
    // redirect: "/order",
    component: pcLayout,
    children: [
      // {
      //   path: "/order",
      //   name: "Order",
      //   component: () => import("@/views/pc/order/index"),
      //   meta: {
      //     title: "预约页",
      //     keepAlive: true,
      //   },
      // },
      {
        path: "/advert",
        name: "Advert",
        component: () => import("@/views/pc/advert/index"),
        meta: {
          title: "宣传页",
          keepAlive: false,
        },
      },
      {
        path: "/payment",
        name: "Payment",
        component: () => import("@/views/pc/payment/index"),
        meta: {
          title: "支付",
          keepAlive: false,
        },
      },
      {
        path: "/payhome",
        name: "Payhome",
        component: () => import("@/views/pc/payhome/index"),
        meta: {
          title: "支付",
          keepAlive: false,
        },
      },
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/pc/home/index"),
        meta: {
          title: "首页",
          keepAlive: true,
        },
      },
      {
        path: "/newspaper",
        name: "newspaper",
        component: () => import("@/views/pc/newspaper/index"),
        meta: {
          title: "板报",
          keepAlive: true,
        },
      },
      {
        path: "/information",
        name: "information",
        component: () => import("@/views/pc/information/index"),
        meta: {
          title: "资料",
          keepAlive: false,
        },
      },
      {
        path: "/detail",
        name: "Detail",
        component: () => import("@/views/pc/detail/index"),
        meta: {
          title: "详情",
          keepAlive: false,
        },
      },
      {
        path: "/mediaPage",
        name: "Media",
        component: () => import("@/views/pc/mediaPage/index"),
        meta: {
          title: "详情",
          keepAlive: false,
        },
      },
    ],
  },
];

const routesM = [
  {
    path: "/",
    name: "mbLayout",
    redirect: "/home",
    // redirect: "/order",
    component: mbLayout,
    children: [
      // {
      //   path: "/order",
      //   name: "Order",
      //   component: () => import("@/views/mobile/order/index"),
      //   meta: {
      //     title: "预约页",
      //     keepAlive: true,
      //   },
      // },

      {
        path: "/advert",
        name: "Advert",
        component: () => import("@/views/mobile/advert/index"),
        meta: {
          title: "宣传页",
          keepAlive: false,
        },
      },
      {
        path: "/payment",
        name: "Payment",
        component: () => import("@/views/mobile/payment/index"),
        meta: {
          title: "支付",
          keepAlive: false,
        },
      },
      {
        path: "/payhome",
        name: "Payhome",
        component: () => import("@/views/mobile/payhome/index"),
        meta: {
          title: "支付",
          keepAlive: false,
        },
      }, 
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/mobile/home/index"),
        meta: {
          title: "首页",
          keepAlive: false,
        },
      },
      {
        path: "/newspaper",
        name: "newspaper",
        component: () => import("@/views/mobile/newspaper/index"),
        meta: {
          title: "板报",
          keepAlive: false,
        },
      },
      {
        path: "/information",
        name: "information",
        component: () => import("@/views/mobile/information/index"),
        meta: {
          title: "资料",
          keepAlive: false,
        },
      },
      {
        path: "/detail",
        name: "Detail",
        component: () => import("@/views/mobile/detail/index"),
        meta: {
          title: "详情",
          keepAlive: false,
        },
      },
      {
        path: "/downgame",
        name: "Download",
        component: () => import("@/views/mobile/download/index"),
        meta: {
          title: "下载",
          keepAlive: true,
        },
      },
      {
        path: "/upload",
        name: "Upload",
        component: () => import("@/views/mobile/upload/index"),
        meta: {
          title: "上传",
          keepAlive: true,
        },
      },
    ],
  },
];

const router_obj = { pc: routesP, mobile: routesM };

const routes = router_obj[utils.isClientType()];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
